import { Controller } from "@hotwired/stimulus"

// Live preview of color changes on the affiliate whitelabel settings page.
// Mirrors color-input changes onto a mini-mockup so the affiliate sees
// their palette without a round-trip to the server.
//
// TOKEN-1 (#13368): the controller never paints a block directly. It writes
// the four brand colours as `--gl-whitelabel-preview-*` custom properties on the preview
// root, and `components/_whitelabel-preview.scss` reads them — the same
// data-colour bridge the lead-type pills use. The template renders the same
// properties server-side so the first frame is already in colour.
const PROPERTIES = Object.freeze({
  primaryColor: "--gl-whitelabel-preview-primary",
  secondaryColor: "--gl-whitelabel-preview-secondary",
  accentColor: "--gl-whitelabel-preview-accent",
  sidebarColor: "--gl-whitelabel-preview-sidebar"
})

export default class extends Controller {
  static targets = ["preview", "primaryColor", "secondaryColor", "accentColor", "sidebarColor"]

  connect() {
    this.updateColors()
  }

  updateColors() {
    if (!this.hasPreviewTarget) return

    for (const [target, property] of Object.entries(PROPERTIES)) {
      const input = this.targets.find(target)
      if (input && input.value) this.previewTarget.style.setProperty(property, input.value)
    }
  }
}
